import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  // isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Header, Loader } from 'semantic-ui-react'
import { isAdmin } from './helpers'

class Messages extends Component {

  state = {
    column: null,
    data: [],
    direction: null,
    loading: true,
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { messages, users } = this.props
    // set data from firebase
    if(isLoaded(messages) && isLoaded(users) && this.state.data.length === 0) {

      // Pull messages from firebase
      let dataArray = _.filter(messages, m => m.body)

      // no date field, so reversing array puts most recent at top, i think
      dataArray = _.reverse(dataArray)

      // Join username from users list
      dataArray = _.map(dataArray, m => {
        let user = _.find(users, (u,key) => { return key === m.from})
        return {...m, username: user ? user.username : m.from}
      })

      // Set table data. In this format, client can sort
      this.setState({data: dataArray, loading: false});
    }
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })

      return
    }

    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  render() {

    if(!isAdmin(this.props.auth))
      return null


    const { column, data, direction, loading } = this.state

    if(loading)
      return <Loader />

    return (
      <Container>

        <Header as='h2'>Messages ({data.length})</Header>

        <Table sortable celled >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={column === 'topic' ? direction : null}
                onClick={this.handleSort('topic')}
              >
                Topic
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={column === 'from' ? direction : null}
                onClick={this.handleSort('from')}
              >
                From
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={column === 'message' ? direction : null}
                onClick={this.handleSort('message')}
              >
                Message
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(data, ({ from, username, title, body, topic }) => (
              <Table.Row key={Math.random()}>
                <Table.Cell>{topic}</Table.Cell>
                <Table.Cell>{username}</Table.Cell>
                <Table.Cell>{title} {body}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

      </Container>
    )
  }
}

export default compose(
  firebaseConnect([
    'messages', 'users'
  ]),
  connect((state) => ({
    messages: state.firebase.data.messages,
    users: state.firebase.data.users,
    auth: state.firebase.auth,
  }))
)(Messages)



// WEBPACK FOOTER //
// ./src/components/pages/admin/MessagesList.js